import { useActivePage } from "@toolpad/core";
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router";

export interface SelectionProviderProps {
  children: React.ReactNode;
}

export type CityEscapeItemSelection = {
  cityEscapeId: string | null;
  enigmaId?: string | null;
};

type SelectionContextType = {
  active: CityEscapeItemSelection;
  setActiveSelection: (selection: Partial<CityEscapeItemSelection>) => void;
};

const SelectionContext = createContext<SelectionContextType | undefined>(
  undefined
);

export const SelectionProvider: React.FC<SelectionProviderProps> = ({
  children,
}) => {
  const activePage = useActivePage();
  const [searchParams] = useSearchParams();

  // const searchParams = new URLSearchParams(window.location.search);

  const [activeSelection, setActiveSelection] =
    useState<CityEscapeItemSelection>({
      cityEscapeId: searchParams.get("ce"),
      enigmaId: searchParams.get("enigma"),
    });

  useEffect(() => {
    const ceId = searchParams.get("ce");
    const enigmaId = searchParams.get("enigma");
    setActiveSelection({
      cityEscapeId: ceId,
      enigmaId: enigmaId,
    });
  }, [searchParams]);

  const value: SelectionContextType = useMemo(
    () => ({
      active: activeSelection,
      setActiveSelection: (selection: Partial<CityEscapeItemSelection>) => {
        setActiveSelection((prev) => ({ ...prev, ...selection }));
        const params = new URLSearchParams();
        if (activeSelection.cityEscapeId) {
          params.set("ce", activeSelection.cityEscapeId);
        }
        if (activeSelection.enigmaId) {
          params.set("enigma", activeSelection.enigmaId);
        }

        const new_path = `${activePage?.path ?? ""}?${params.toString()}`;

        window.history.pushState(
          {
            ...window.history.state,
          },
          "",
          new_path
        );
        console.trace(
          "Setting active selection",
          selection,
          activeSelection,
          window.location.href
        );
      },
    }),
    [activeSelection, setActiveSelection]
  );

  return (
    <SelectionContext.Provider value={value}>
      {children}
    </SelectionContext.Provider>
  );
};

// Custom hook to use IndexedDb
export const useSelection = (): SelectionContextType => {
  const context = useContext(SelectionContext);

  if (context == null) {
    throw new Error("useSelection must be used within a SelectionProvider");
  }

  return context;
};
